import AppWraper, { FOOTER_HEIGHT, HEADER_HEIGHT } from './layouts';

export { FOOTER_HEIGHT, HEADER_HEIGHT };

export default AppWraper;
